import { GetLatestEventsResponseSchema } from '@weft/api-definition';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../services/api';

type UseLatestEventsPayload = Parameters<ReturnType<typeof getPrivateApi>['getLatestEvents']>[0];

export function useLatestEvents(payload: UseLatestEventsPayload) {
  return useQuery(
    ['events', payload],
    async ({ signal }) => {
      const privateApi = getPrivateApi();
      const getLatestEventsResponse = await privateApi.getLatestEvents({
        ...payload,
      }, { signal });

      return GetLatestEventsResponseSchema.parse(getLatestEventsResponse);
    },
    {
      keepPreviousData: true,
    },
  );
}